import React from 'react';
import Logo from '../Base';
import Styled from './style';

const Index = (props) => {
  return <Logo {...props} Styled={Styled} />;
};

export default Index;
